import { Form, Input, InputNumber } from "antd";
import React from "react";

const TotalFemaleCount: React.FC = () => {
  return (
    <Form.Item
      name="femalePopulation"
      label="Total Females"
      rules={[
        {
          required: true,
          message: "Please enter the total female count",
        },
      ]}
    >
      <InputNumber
        changeOnWheel={false}
        controls={false}
        style={{ width: "100%" }}
      />
    </Form.Item>
  );
};

export default TotalFemaleCount;
